import Image from 'app/Components/Shared/Image/image';
import React, {useCallback, useEffect, useMemo} from 'react';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import Config from '../../../../Config';
import NavButtonsList from 'app/Components/Block/HeaderMainBlock/Desktop/NavButtonsList';

const NavButton = ({item, index, setTabsUrlList, props}) => {
  const {headerData, toggleTabButton, context, isBusinessNavigation, isBusinessNavigationMode} = props;
  const {tabs, tabIndex, navButtonsCurrent, showTabItems, arrowIndex, navItemIndex} = headerData;
  const buttons = item?.navButtonsNew?.expandedValue || item?.regularButtons?.expandedValue;


  const handleTabClick = useCallback((index) => {
    props.setNavItemIndex(index);
  }, [props]);

  const handleClick = useCallback(() => {
    handleTabClick(index);
    if (item?.regularButtons?.value) {
      toggleTabButton(index);
    } else {
      setTabsUrlList((currentList) => {
        return {[item?.link?.value]: index, ...currentList};
      });
    }
    if (item?.link?.value) {
      prepareSameWindowUrlWithNavigateTo(item?.link?.value, context);
    }
  }, [handleTabClick, index, item, toggleTabButton, setTabsUrlList, context]);

  const handleMouseEnter = useCallback(() => {
    if (item?.regularButtons?.value) {
      toggleTabButton(index);
    }
  }, [item, toggleTabButton, index]);

  const handleMouseLeave = useCallback(() => {
    if (item?.regularButtons?.value) {
      toggleTabButton(index);
    }
  }, [item, toggleTabButton, index]);

  const isSelected = useMemo(() => index + buttons?.length === navItemIndex, [index, buttons, navItemIndex]);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
    <span
      key={index}
      className={`nav-item ${index === navItemIndex && 'selected'}`}
    >
      <div
        className="nav-head-link-wrapper"
        onClick={handleClick}>
        {item?.icon?.value && (
          <Image className="nav-item-icon"
               src={Config.epiBaseUrl + item?.icon?.expandedValue?.url} alt={'item' + index + 'alt'} />
        )}
        <span
          className={`${isBusinessNavigation || tabs[tabIndex]?.isBusinessTab?.value === true ? 'business' : ''} nav-item-regular`}>
          {item?.text?.value}
        </span>
        {item?.regularButtons?.value && (
          <Image className={`nav-item-arrow ${showTabItems && arrowIndex === index ? 'up' : 'down'}`}
            src={
              !isBusinessNavigation && !isBusinessNavigationMode ? require('../images/down.svg') : require('../images/down-white.svg')
            } />
        )}
      </div>
      {buttons && showTabItems && arrowIndex === index &&
        <NavButtonsList props={props} buttons={buttons} index={index} setTabsUrlList={setTabsUrlList} />}
    </span>
    </div>
  );
};


export default NavButton;
